import React, { Component } from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import ConfDtb from '../../../../config/confDtb';
import { dataDosen } from '../../../../dummy-data/dosen';

class TabelDosenTetap extends Component {

    state = {
        ListDosenTetap: [],
        statusData: '',
    }

    componentDidMount = () => {
        const dosenList = dataDosen.map((d, idx) => ({
            No: idx + 1,
            nomer: d.dosen_id,
            kode_dosen: d.nidn,
            label: d.nama,
            id_hidden: d.status === 'Aktif' ? 1 : 0
        }));

        setTimeout(() => {
            this.setState({
                ListDosenTetap: dosenList,
                statusData: 200
            });
            ConfDtb();
        }, 300);
    }

    render() {
        return (
            <Fragment>
                {
                    this.state.statusData != 200 ?
                        <div id="spinner" className="loader-1 colorful mt-5 mb-5">
                            <div className="dot" />
                            <div className="dot" />
                            <div className="dot" />
                        </div>
                        :
                        <table id="tabel" className="display expandable-table table-striped" style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Kode dosen</th>
                                    <th>Nama dosen</th>
                                    <th>Status</th>
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.ListDosenTetap.map((dosenTetap, index) => {
                                        return (
                                            <Fragment key={index}>
                                                <tr className="dark">
                                                    <td>{index + 1}</td>
                                                    <td>{dosenTetap.kode_dosen}</td>
                                                    <td>{dosenTetap.label}</td>
                                                    <td>
                                                        {
                                                            dosenTetap.id_hidden == 1 ?
                                                                <span className="badge badge-success">Aktif</span>
                                                                :
                                                                <span className="badge badge-danger">Tidak Aktif</span>
                                                        }
                                                    </td>
                                                    <td>
                                                        <Link
                                                            className="btn btn-primary"
                                                            style={{ padding: '10px', borderRadius: '5px' }}
                                                            target={"_blank"}
                                                            to={"/data-dosen/detail/" + dosenTetap.nomer}
                                                        >
                                                            <i className="fa fa-eye" />&nbsp;&nbsp;Detail
                                                        </Link>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                }
            </Fragment>
        );
    }
}

export default TabelDosenTetap;
